export default __webpack_public_path__ + "images/apartaestudioDefault.cc5aa43156f0a942aea009e1c44a0c4a.jpg";